import { DealersData, DealersState, State } from '../../../types'

export const FETCH_GET_DEALERS_PENDING = 'dealers//FETCH_GET_DEALERS_PENDING'
export const FETCH_GET_DEALERS_DONE = 'dealers//FETCH_GET_DEALERS_DONE'
export const FETCH_GET_DEALERS_ERROR = 'dealers//FETCH_GET_DEALERS_ERROR'

export interface FetchDealersPendingAction {
  type: typeof FETCH_GET_DEALERS_PENDING
}

export interface FetchDealersDoneAction {
  type: typeof FETCH_GET_DEALERS_DONE
  payload: { data: DealersData }
}

export interface FetchDealersErrorAction {
  type: typeof FETCH_GET_DEALERS_ERROR
  payload: { err: unknown }
}

export type DealersAction =
  | FetchDealersPendingAction
  | FetchDealersDoneAction
  | FetchDealersErrorAction

export function pending(): FetchDealersPendingAction {
  return { type: FETCH_GET_DEALERS_PENDING }
}

export function done(data: DealersData): FetchDealersDoneAction {
  return { type: FETCH_GET_DEALERS_DONE, payload: { data } }
}

export function error(err: unknown): FetchDealersErrorAction {
  return { type: FETCH_GET_DEALERS_ERROR, payload: { err } }
}

export function getDealersData(store: State): DealersData {
  return store.dealers.data || ({} as DealersData)
}

const initialState: DealersState = {
  pending: false,
  data: {} as DealersData,
  error: null,
}

export default function dealersReducer(
  state: DealersState = initialState,
  action: DealersAction
): DealersState {
  switch (action.type) {
    case FETCH_GET_DEALERS_PENDING:
      return {
        ...state,
        data: {} as DealersData,
        pending: true,
        error: null,
      }

    case FETCH_GET_DEALERS_DONE:
      return {
        ...state,
        data: action.payload.data,
        pending: false,
        error: null,
      }
    case FETCH_GET_DEALERS_ERROR:
      return {
        ...state,
        data: {} as DealersData,
        pending: false,
        error: true,
      }

    default:
      return state
  }
}
